import api from '@/api'

class Tahun {
  get () {
    return new Promise((resolve, reject) => {
      api.get('/v1/tahun')
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  getOne (id) {
    return new Promise((resolve, reject) => {
      api.get(`/v1/tahun/${id}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  post (body) {
    return new Promise((resolve, reject) => {
      api.post('/v1/tahun', body)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  update (body, id) {
    return new Promise((resolve, reject) => {
      api.put(`/v1/tahun/${id}`, body)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }

  delete (id) {
    return new Promise((resolve, reject) => {
      api.delete(`/v1/tahun/${id}`)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData)
          }
        })
        .catch(e => {
          // FIXME: Tell our user when we got some errors
          reject(e.response)
        })
    })
  }
}

export default new Tahun()



// WEBPACK FOOTER //
// ./src/helper/data-master/tahun.js